export const MIN_INDEX_FOR_SECOND_ROW = 3;
